import { Route } from "react-router-dom";
import GetAllMajor from "@/components/CRM/Setup/UniversitySetup/Major/GetAllMajor";

const MajorRoutes = [
    <Route
        path="major"
        element={<GetAllMajor />}
        key="major-list"
    />,
];

export default MajorRoutes;
